module.exports = __webpack_public_path__ + "static/media/delete_outline.cc58cf97.svg";